import { useTranslation } from 'react-i18next'
import { OrganizationCompanySaveActions } from '@/features/organization-settings/components/organization-company-save-actions'
import { OrganizationContactSectionCard } from '@/features/organization-settings/components/organization-contact-section-card'
import { ContentSection } from '@/features/settings/components/content-section'
import { useSupplierOrganizationForm } from '@/features/suppliers/context/supplier-organization-form-context'

export function SupplierOrganizationContactPage() {
  const { t } = useTranslation(['installations', 'common'])
  const {
    state,
    isSaving,
    isSaveDisabled,
    saveDisabledHint,
    onContactChange,
    onSaveChanges,
  } = useSupplierOrganizationForm()

  return (
    <ContentSection
      title={t('installations:suppliers.edit.pages.contact.title')}
      desc={t('installations:suppliers.edit.pages.contact.description')}
    >
      <div className="space-y-6">
        <OrganizationContactSectionCard
          contactName={state.contactName}
          contactEmail={state.contactEmail}
          contactPhoneNumber={state.contactPhoneNumber}
          showRequiredIndicators={false}
          variant="plain"
          onContactChange={onContactChange}
        />

        <OrganizationCompanySaveActions
          saveLabel={t('common:actions.save', { ns: 'common' })}
          isSaving={isSaving}
          isSaveDisabled={isSaveDisabled}
          saveDisabledHint={saveDisabledHint}
          onSave={onSaveChanges}
        />
      </div>
    </ContentSection>
  )
}
